// extracted by mini-css-extract-plugin
module.exports = {"App":"EledoPageLoader_App__22uQ1","Loader":"EledoPageLoader_Loader__Ko6S5","LoaderImage":"EledoPageLoader_LoaderImage__2t5Oi"};